// 活动
import * as activity from '@/api/activity'
// 成员
import * as member from '@/api/member/member'
// JCRing成员
import * as JCRing_member from '@/api/JCRing_member/member'
// 一体机
import * as machine from '@/api/machine/machine'
// 小白康品
import * as ijoou from '@/api/ijoou/report'

// 引出
export default {
  activity,
  member,
  machine,
  ijoou,
  JCRing_member
}



// WEBPACK FOOTER //
// ./src/api/export.js